import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";

export async function getOutlookIntegrations(
  client: RedoMerchantClient,
  { signal }: { signal?: AbortSignal } = {},
): Promise<any> {
  const response = await client.client.get("support/outlook", {
    headers: client.authorization(),
    signal,
  });
  return response.data;
}

export async function deleteOutlookIntegration(
  client: RedoMerchantClient,
  {
    integrationId,
    deleteConversations,
    signal,
  }: {
    integrationId: string;
    deleteConversations: boolean;
    signal?: AbortSignal;
  },
): Promise<void> {
  const params = new URLSearchParams();
  params.set("deleteConversations", deleteConversations.toString());
  const response = await client.client.delete(
    `support/outlook/${integrationId}`,
    { headers: client.authorization(), params, signal },
  );
  return response.data;
}
